import React from "react"

const EmptyStateImage = () => {
  return (
    <svg
      width={275}
      height={174}
      viewBox="0 0 275 174"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M69.0512 129.125C40.9801 97.9174 62.9135 86.3254 77.7273 76.2584C94.821 64.6425 83.3279 41.4288 93.3645 29.8446C113.997 6.03128 139.881 23.2834 160.721 46.4513C188.792 77.6584 206 124.688 165.713 144.293C125.427 163.899 97.1224 160.332 69.0512 129.125Z"
        fill="#E8F7F9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M228.214 47.3297C240.728 63.3198 228.228 69.3387 219.616 74.5555C209.679 80.5749 214.013 92.4924 207.818 98.4781C195.082 110.783 182.672 101.969 173.381 90.0977C160.867 74.1075 155.307 49.9487 178.139 39.761C200.971 29.5732 215.7 31.3396 228.214 47.3297Z"
        fill="#E8F7F9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.6166 54.7874C41.3231 54.113 43.8351 67.7574 44.7017 77.7887C45.7018 89.3637 33.5218 92.893 32.342 101.426C29.9167 118.968 44.3547 123.792 59.4205 124.292C79.714 124.967 102.503 115.208 97.2632 90.7611C92.0238 66.3144 81.9101 55.4619 61.6166 54.7874Z"
        fill="#E8F7F9"
      />
      <g filter="url(#filter0_d_245_6871)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M176.667 3.86169C176.667 3.86169 197.504 32.2695 197.504 47.7646C197.504 63.2598 192.695 131.697 192.695 131.697C192.695 131.697 189.49 136.862 176.667 136.862C163.845 136.862 159.037 131.697 159.037 131.697C159.037 131.697 154.228 58.0947 155.831 45.1821C157.434 32.2695 176.667 3.86169 176.667 3.86169Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M176.99 12.8617C176.99 12.8617 183.062 21.557 187.288 30.7036C187.288 30.7036 181.172 28.8727 176.998 28.8277C172.919 28.784 166.855 30.8617 166.855 30.8617C171.092 22.016 176.99 12.8617 176.99 12.8617Z"
          fill="#6ACBDD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M191.828 53.8617L188.423 36.2183C188.423 36.2183 183.315 34.8617 176.504 34.8617C169.693 34.8617 164.585 36.2183 164.585 36.2183L161.179 53.8617C161.179 53.8617 166.969 51.3284 176.504 51.3284C186.04 51.3284 191.828 53.8617 191.828 53.8617Z"
          fill="#6ACBDD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M173.949 101.862H176.788C184.436 101.862 190.693 96.9559 190.693 90.9599V69.7635C190.693 63.7675 184.436 58.8617 176.788 58.8617H173.949C166.302 58.8617 160.044 63.7675 160.044 69.7635V90.9599C160.044 96.9559 166.302 101.862 173.949 101.862Z"
          fill="#D8EEEF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M175.936 106.862C182.804 106.862 188.423 102.363 188.423 96.8644V70.859C188.423 65.3607 182.804 60.8617 175.936 60.8617C169.069 60.8617 163.45 65.3607 163.45 70.859V96.8644C163.45 102.363 169.069 106.862 175.936 106.862Z"
          fill="#FEFEFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M168.009 98.8617H183.863C185.127 98.8617 186.153 98.0774 186.153 97.1093V70.5773C186.153 66.3164 181.641 62.8617 176.076 62.8617C170.356 62.8617 165.72 66.4128 165.72 70.792V97.1093C165.72 98.0774 166.744 98.8617 168.009 98.8617Z"
          fill="#232F3E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M167.654 98.8617H184.217C185.285 98.8617 186.153 98.1909 186.153 97.3641V79.4553C186.153 75.814 182.34 72.8617 177.635 72.8617H174.472C169.639 72.8617 165.72 75.8959 165.72 79.6386V97.3641C165.72 98.1909 166.586 98.8617 167.654 98.8617Z"
          fill="#232F3E"
        />
        <path
          opacity={0.336102}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M167.396 107.862H184.477C185.402 107.862 186.153 108.428 186.153 109.126V121.297C186.153 124.37 182.85 126.862 178.777 126.862H173.3C169.113 126.862 165.72 124.302 165.72 121.143V109.126C165.72 108.428 166.471 107.862 167.396 107.862Z"
          fill="#232F3E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M182.747 61.8617H180.477V55.8617H182.747V61.8617Z"
          fill="#FEFEFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M187.288 66.8617H185.017V59.8617H187.288V66.8617Z"
          fill="#FEFEFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M172.531 61.8617H170.261V55.8617H172.531V61.8617Z"
          fill="#FEFEFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M167.99 66.8617H165.72V59.8617H167.99V66.8617Z"
          fill="#FEFEFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M183.882 72.5379C183.882 71.6122 182.406 70.8617 180.585 70.8617H179.579C177.758 70.8617 176.282 71.6122 176.282 72.5379V74.4617H183.882V72.5379Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M175.591 72.5379C175.591 71.6122 174.151 70.8617 172.375 70.8617H171.395C169.619 70.8617 168.179 71.6122 168.179 72.5379L167.99 74.4617H175.591V72.5379Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M183.882 76.0236C183.882 76.4865 182.406 76.8617 180.585 76.8617H179.579C177.758 76.8617 176.282 76.4865 176.282 76.0236V75.0617H183.882V76.0236Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M175.591 76.0236C175.591 76.4865 174.151 76.8617 172.375 76.8617H171.395C169.619 76.8617 168.179 76.4865 168.179 76.0236L167.99 75.0617H175.591V76.0236Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M183.882 111.538C183.882 110.612 182.406 109.862 180.585 109.862H179.579C177.758 109.862 176.282 110.612 176.282 111.538V113.462H183.882V111.538Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M175.591 111.538C175.591 110.612 174.151 109.862 172.375 109.862H171.395C169.619 109.862 168.179 110.612 168.179 111.538L167.99 113.462H175.591V111.538Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M183.882 115.024C183.882 115.486 182.406 115.862 180.585 115.862H179.579C177.758 115.862 176.282 115.486 176.282 115.024V114.062H183.882V115.024Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M175.591 115.024C175.591 115.486 174.151 115.862 172.375 115.862H171.395C169.619 115.862 168.179 115.486 168.179 115.024L167.99 114.062H175.591V115.024Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M170.256 99.3076C171.012 99.3076 171.626 97.8626 171.626 96.0802V95.0963C171.626 93.3137 171.012 91.8689 170.256 91.8689H168.684V99.3076H170.256Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M170.256 91.1926C171.012 91.1926 171.626 89.7836 171.626 88.0454V87.086C171.626 85.3479 171.012 83.9388 170.256 83.9388L168.684 83.7539V91.1926H170.256Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M167.173 98.9695C166.871 98.9695 166.626 97.5245 166.626 95.742V94.7582C166.626 92.9755 166.871 91.5307 167.173 91.5307H167.802V98.9695H167.173Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M167.173 90.8545C166.871 90.8545 166.626 89.4454 166.626 87.7073V86.7479C166.626 85.0098 166.871 83.6007 167.173 83.6007L167.802 83.4157V90.8545H167.173Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M180.481 99.3076C179.725 99.3076 179.112 97.8626 179.112 96.0802V95.0963C179.112 93.3137 179.725 91.8689 180.481 91.8689H182.053V99.3076H180.481Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M180.481 91.1926C179.725 91.1926 179.112 89.7836 179.112 88.0454V87.086C179.112 85.3479 179.725 83.9388 180.481 83.9388L182.053 83.7539V91.1926H180.481Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M183.564 98.9695C183.867 98.9695 184.112 97.5245 184.112 95.742V94.7582C184.112 92.9755 183.867 91.5307 183.564 91.5307H182.936V98.9695H183.564Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M183.564 90.8545C183.867 90.8545 184.112 89.4454 184.112 87.7073V86.7479C184.112 85.0098 183.867 83.6007 183.564 83.6007L182.936 83.4157V90.8545H183.564Z"
          fill="white"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.61743 73.9092C1.61743 73.9092 1.86909 73.9286 2.34663 73.9616C2.5854 73.9781 2.87578 74.0002 3.22425 74.0249C3.57921 74.0327 3.98581 74.0375 4.4505 74.0422C4.92162 74.0554 5.42509 74.026 5.98665 74.0049C6.54816 73.9981 7.14854 73.9287 7.7942 73.8536C7.95559 73.8363 8.12344 73.816 8.29128 73.7987C8.45915 73.7643 8.62057 73.7327 8.7949 73.7012C8.94987 73.6668 9.09835 73.6495 9.2598 73.6038C9.42771 73.5552 9.60854 73.5009 9.78291 73.4523C10.4739 73.2382 10.9973 72.9733 11.5142 72.6914C12.5094 72.1192 13.3947 71.5813 14.6669 71.1872C15.9263 70.7818 17.3594 70.6483 18.9209 70.8067C20.5019 70.9536 22.1274 71.387 23.824 71.8287C25.5334 72.2732 27.3008 72.7828 29.3781 73.1641C30.4427 73.3462 31.5074 73.4971 32.8173 73.5425C33.353 73.5499 33.7854 73.5774 34.4308 73.5618C34.7277 73.5583 35.0375 73.5549 35.328 73.5457L36.1865 73.4929C38.4715 73.3547 40.609 72.8 42.101 72.2608C43.4573 71.7899 44.6128 71.6826 46.1226 71.9204C46.3226 71.9512 46.5549 71.9791 46.7355 72.0127L47.2516 72.1109C47.5936 72.1641 47.9548 72.2654 48.3032 72.3356C48.9999 72.4958 49.6772 72.6702 50.3287 72.8475C50.9867 73.0191 51.6188 73.1936 52.2575 73.3454C52.4123 73.3819 52.5736 73.4184 52.7284 73.455L52.8445 73.4831L52.9413 73.5056L52.9994 73.5168L53.2316 73.5589C53.5413 73.6149 53.8187 73.6767 54.18 73.7157C55.535 73.9028 56.6838 73.8749 57.6069 73.8247C58.5299 73.766 59.2143 73.671 59.6791 73.6076C60.1375 73.5386 60.3828 73.504 60.3828 73.504C60.3828 73.504 60.1311 73.5159 59.6405 73.5339C59.1629 73.5548 58.4529 73.562 57.5816 73.5553C56.7168 73.5345 55.6391 73.4517 54.6522 73.2439C54.4135 73.2047 54.1297 73.1174 53.8458 73.0442L53.633 72.9851L53.5814 72.971C53.6459 72.9851 53.5685 72.9654 53.5685 72.9626L53.4653 72.9287L53.059 72.7963C52.5108 72.6103 51.9368 72.413 51.3305 72.2072C50.7242 71.9986 50.0728 71.7759 49.3569 71.5591C48.9764 71.4549 48.641 71.345 48.1959 71.2467C47.7637 71.1427 47.3314 71.0443 46.9379 70.9771C46.0799 70.8031 44.899 70.6638 43.705 70.723C43.1112 70.7413 42.5172 70.822 41.9877 70.9252C41.7165 70.9683 41.4453 71.0426 41.1741 71.1084C40.8706 71.18 40.7479 71.2313 40.5218 71.2942L39.9148 71.4741C39.7339 71.5256 39.5531 71.5855 39.3658 71.6341C38.9849 71.7229 38.6103 71.8258 38.2036 71.8947C37.4223 72.0523 36.5831 72.1477 35.731 72.2091L35.0855 72.2445C34.8725 72.2506 34.666 72.2482 34.453 72.2515C34.0851 72.2693 33.4978 72.2336 33.0073 72.2205C32.2781 72.1908 31.3554 72.0708 30.5232 71.9166C28.7941 71.6168 27.0913 71.1525 25.3174 70.7053C23.5435 70.2581 21.6403 69.8168 19.4206 69.6457C18.3236 69.5629 17.1231 69.5683 16.0385 69.7152C14.9539 69.8593 14.0045 70.1109 13.2488 70.4018C12.8742 70.5472 12.4543 70.7183 12.2023 70.8521C12.0473 70.9347 11.9504 70.9718 11.7501 71.0857L11.3365 71.3304C10.8388 71.6577 10.4445 71.979 10.0631 72.252C9.68818 72.5251 9.2746 72.7699 8.86117 72.9438L8.564 73.0749C8.45419 73.1176 8.2863 73.1549 8.15068 73.1977C8.02798 73.232 7.90528 73.2663 7.78257 73.3034C7.64053 73.3264 7.50494 73.3522 7.3758 73.3809C6.83345 73.4841 6.31693 73.5788 5.80048 73.6338C5.29049 73.6944 4.82565 73.7663 4.39318 73.7842C3.95423 73.8164 3.56693 73.8455 3.23125 73.8718C2.87627 73.881 2.57935 73.8902 2.34054 73.8964C1.87584 73.903 1.61743 73.9092 1.61743 73.9092Z"
        fill="#6ACBDD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.7464 64.9242C25.7464 64.9242 25.8696 64.9435 26.1034 64.9766C26.2203 64.9931 26.3624 65.0152 26.533 65.04C26.7068 65.0477 26.9059 65.0525 27.1333 65.0572C27.364 65.0704 27.6105 65.041 27.8854 65.02C28.1603 65.0131 28.4542 64.9438 28.7703 64.8687C28.8493 64.8514 28.9315 64.8311 29.0137 64.8138C29.0958 64.7794 29.1749 64.7478 29.2602 64.7163C29.3361 64.6819 29.4088 64.6646 29.4878 64.6189C29.57 64.5703 29.6585 64.516 29.7439 64.4675C30.0822 64.2533 30.3384 63.9884 30.5915 63.7066C31.0787 63.1344 31.5121 62.5965 32.1349 62.2024C32.7515 61.7971 33.4531 61.6636 34.2175 61.822C34.9915 61.969 35.7873 62.4023 36.6179 62.8441C37.4548 63.2886 38.32 63.7982 39.3371 64.1796C39.8582 64.3617 40.3794 64.5126 41.0208 64.5581C41.283 64.5655 41.4947 64.5929 41.8107 64.5774C41.956 64.5739 42.1077 64.5705 42.2499 64.5613L42.6702 64.5085C43.7888 64.3704 44.8353 63.8157 45.5657 63.2765C46.2297 62.8057 46.7954 62.6983 47.5345 62.9362C47.6324 62.967 47.7462 62.9949 47.8346 63.0285L48.0873 63.1267C48.2547 63.1799 48.4315 63.2812 48.6021 63.3514C48.9432 63.5116 49.2748 63.686 49.5937 63.8633C49.9158 64.035 50.2253 64.2095 50.538 64.3613C50.6138 64.3978 50.6927 64.4344 50.7685 64.4709L50.8254 64.499L50.8728 64.5215L50.9012 64.5327L51.0149 64.5748C51.1665 64.6309 51.3023 64.6927 51.4792 64.7316C52.1425 64.9188 52.705 64.8909 53.1569 64.8407C53.6088 64.7821 53.9438 64.687 54.1714 64.6237C54.3958 64.5546 54.5159 64.5201 54.5159 64.5201C54.5159 64.5201 54.3926 64.532 54.1525 64.55C53.9186 64.5709 53.5711 64.578 53.1445 64.5713C52.7211 64.5505 52.1935 64.4676 51.7103 64.2598C51.5935 64.2206 51.4545 64.1333 51.3156 64.0602L51.2114 64.0011L51.1861 63.987C51.2177 64.001 51.1798 63.9813 51.1798 63.9785L51.1293 63.9447L50.9304 63.8122C50.662 63.6262 50.381 63.4289 50.0841 63.2231C49.7873 63.0145 49.4684 62.7918 49.118 62.5749C48.9316 62.4708 48.7675 62.3609 48.5495 62.2626C48.3379 62.1585 48.1263 62.0602 47.9337 61.9929C47.5136 61.8189 46.9355 61.6796 46.3509 61.7388C46.0602 61.757 45.7695 61.8377 45.5102 61.9409C45.3775 61.984 45.2447 62.0584 45.1119 62.1241C44.9633 62.1957 44.9033 62.247 44.7926 62.3099L44.4954 62.4898C44.4069 62.5413 44.3183 62.6012 44.2267 62.6498C44.0402 62.7385 43.8568 62.8414 43.6577 62.9103C43.2752 63.068 42.8643 63.1633 42.4472 63.2247L42.1312 63.2601C42.0269 63.2662 41.9258 63.2638 41.8215 63.2671C41.6414 63.2848 41.3539 63.2492 41.1138 63.2361C40.7568 63.2064 40.305 63.0864 39.8976 62.9321C39.0511 62.6323 38.2174 62.1679 37.349 61.7207C36.4806 61.2734 35.5489 60.8321 34.4621 60.6609C33.9251 60.5782 33.3374 60.5835 32.8064 60.7304C32.2754 60.8745 31.8106 61.1261 31.4407 61.417C31.2573 61.5624 31.0517 61.7335 30.9283 61.8673C30.8524 61.9499 30.805 61.9869 30.7069 62.1008L30.5045 62.3456C30.2608 62.6728 30.0678 62.9941 29.8811 63.2672C29.6975 63.5402 29.495 63.785 29.2926 63.9589L29.1472 64.09C29.0934 64.1327 29.0112 64.17 28.9448 64.2128C28.8847 64.2471 28.8247 64.2814 28.7646 64.3185C28.6951 64.3415 28.6287 64.3673 28.5655 64.3959C28.3 64.4992 28.0471 64.5939 27.7942 64.6488C27.5446 64.7095 27.317 64.7813 27.1053 64.7993C26.8904 64.8314 26.7008 64.8606 26.5364 64.8868C26.3627 64.896 26.2173 64.9052 26.1004 64.9113C25.8729 64.918 25.7464 64.9242 25.7464 64.9242Z"
        fill="#6ACBDD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M214.617 54.7373C214.617 54.7373 214.869 54.7566 215.347 54.7896C215.585 54.8062 215.876 54.8282 216.224 54.853C216.579 54.8608 216.986 54.8656 217.45 54.8703C217.922 54.8835 218.425 54.854 218.987 54.833C219.548 54.8261 220.149 54.7568 220.794 54.6817C220.956 54.6643 221.123 54.6441 221.291 54.6267C221.459 54.5924 221.621 54.5608 221.795 54.5292C221.95 54.4949 222.098 54.4775 222.26 54.4318C222.428 54.3833 222.609 54.329 222.783 54.2804C223.474 54.0662 223.997 53.8014 224.514 53.5195C225.509 52.9473 226.395 52.4094 227.667 52.0153C228.926 51.6099 230.359 51.4764 231.921 51.6347C233.502 51.7817 235.127 52.215 236.824 52.6567C238.533 53.1012 240.301 53.6108 242.378 53.9922C243.443 54.1743 244.507 54.3252 245.817 54.3706C246.353 54.378 246.785 54.4054 247.431 54.3899C247.728 54.3864 248.038 54.3829 248.328 54.3738L249.186 54.3209C251.471 54.1828 253.609 53.628 255.101 53.0888C256.457 52.618 257.613 52.5106 259.123 52.7485C259.323 52.7793 259.555 52.8071 259.736 52.8408L260.252 52.939C260.594 52.9921 260.955 53.0935 261.303 53.1636C262 53.3238 262.677 53.4982 263.329 53.6755C263.987 53.8471 264.619 54.0216 265.258 54.1734C265.412 54.21 265.574 54.2465 265.728 54.283L265.845 54.3112L265.941 54.3336L265.999 54.3449L266.232 54.3869C266.541 54.443 266.819 54.5048 267.18 54.5437C268.535 54.7309 269.684 54.7029 270.607 54.6528C271.53 54.5941 272.214 54.499 272.679 54.4357C273.137 54.3666 273.383 54.3321 273.383 54.3321C273.383 54.3321 273.131 54.3439 272.641 54.362C272.163 54.3829 271.453 54.39 270.582 54.3834C269.717 54.3625 268.639 54.2797 267.652 54.0719C267.413 54.0327 267.13 53.9454 266.846 53.8723L266.633 53.8132L266.581 53.7991C266.646 53.8131 266.568 53.7935 266.568 53.7906L266.465 53.7568L266.059 53.6244C265.511 53.4383 264.937 53.241 264.33 53.0353C263.724 52.8267 263.073 52.604 262.357 52.3871C261.976 52.283 261.641 52.1731 261.196 52.0748C260.764 51.9708 260.331 51.8724 259.938 51.8052C259.08 51.6312 257.899 51.4918 256.705 51.5511C256.111 51.5694 255.517 51.65 254.988 51.7533C254.717 51.7964 254.445 51.8707 254.174 51.9365C253.871 52.0081 253.748 52.0594 253.522 52.1222L252.915 52.3022C252.734 52.3536 252.553 52.4136 252.366 52.4622C251.985 52.5509 251.61 52.6538 251.204 52.7227C250.422 52.8804 249.583 52.9758 248.731 53.0371L248.086 53.0725C247.873 53.0786 247.666 53.0763 247.453 53.0795C247.085 53.0973 246.498 53.0617 246.007 53.0486C245.278 53.0189 244.355 52.8989 243.523 52.7447C241.794 52.4449 240.091 51.9805 238.317 51.5333C236.543 51.0861 234.64 50.6449 232.421 50.4737C231.324 50.391 230.123 50.3963 229.038 50.5433C227.954 50.6874 227.005 50.939 226.249 51.2299C225.874 51.3753 225.454 51.5464 225.202 51.6802C225.047 51.7628 224.95 51.7999 224.75 51.9137L224.336 52.1585C223.839 52.4857 223.444 52.807 223.063 53.0801C222.688 53.3532 222.275 53.598 221.861 53.7718L221.564 53.9029C221.454 53.9457 221.286 53.9829 221.151 54.0258C221.028 54.0601 220.905 54.0944 220.783 54.1315C220.641 54.1545 220.505 54.1803 220.376 54.2089C219.833 54.3122 219.317 54.4069 218.8 54.4618C218.29 54.5225 217.826 54.5944 217.393 54.6123C216.954 54.6444 216.567 54.6736 216.231 54.6998C215.876 54.7091 215.579 54.7182 215.341 54.7244C214.876 54.7311 214.617 54.7373 214.617 54.7373Z"
        fill="#6ACBDD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M226.099 42.8047C226.216 42.8212 226.358 42.8432 226.528 42.868C226.702 42.8758 226.901 42.8806 227.129 42.8853C227.359 42.8985 227.606 42.869 227.881 42.848C228.156 42.8411 228.45 42.7718 228.766 42.6967C228.845 42.6793 228.927 42.6591 229.009 42.6418C229.091 42.6074 229.17 42.5758 229.256 42.5443C229.331 42.5099 229.404 42.4926 229.483 42.4468C229.565 42.3983 229.654 42.344 229.739 42.2954C230.078 42.0812 230.334 41.8164 230.587 41.5345C231.074 40.9623 231.508 40.4244 232.13 40.0303C232.747 39.6249 233.449 39.4914 234.213 39.6498C234.987 39.7967 235.783 40.23 236.613 40.6718C237.45 41.1162 238.316 41.6258 239.333 42.0072C239.854 42.1893 240.375 42.3402 241.016 42.3856C241.279 42.393 241.49 42.4204 241.806 42.4049C241.952 42.4014 242.103 42.3979 242.246 42.3888L242.666 42.3359C243.784 42.1978 244.831 41.6431 245.561 41.1039C246.225 40.633 246.791 40.5256 247.53 40.7635C247.628 40.7943 247.742 40.8221 247.83 40.8558L248.083 40.954C248.25 41.0071 248.427 41.1085 248.598 41.1786C248.939 41.3388 249.271 41.5132 249.59 41.6905C249.912 41.8621 250.221 42.0366 250.534 42.1885C250.61 42.225 250.689 42.2615 250.764 42.2981L250.821 42.3262L250.869 42.3487L250.897 42.3599L251.011 42.4019C251.162 42.458 251.298 42.5198 251.475 42.5587C252.138 42.7459 252.701 42.7179 253.153 42.6678C253.605 42.6091 253.94 42.5141 254.167 42.4507C254.392 42.3816 254.512 42.3471 254.512 42.3471C254.512 42.3471 254.388 42.359 254.148 42.377C253.914 42.3979 253.567 42.4051 253.14 42.3984C252.717 42.3775 252.189 42.2947 251.706 42.0869C251.589 42.0477 251.45 41.9604 251.311 41.8873L251.207 41.8282L251.182 41.8141C251.213 41.8282 251.176 41.8085 251.176 41.8056L251.125 41.7718L250.926 41.6394C250.658 41.4534 250.377 41.256 250.08 41.0503C249.783 40.8417 249.464 40.619 249.114 40.4022C248.927 40.298 248.763 40.1881 248.545 40.0898C248.334 39.9858 248.122 39.8874 247.929 39.8202C247.509 39.6462 246.931 39.5069 246.347 39.5661C246.056 39.5844 245.765 39.6651 245.506 39.7683C245.373 39.8114 245.24 39.8857 245.108 39.9515C244.959 40.0231 244.899 40.0744 244.788 40.1373L244.491 40.3172C244.403 40.3687 244.314 40.4286 244.222 40.4772C244.036 40.5659 243.852 40.6688 243.653 40.7378C243.271 40.8954 242.86 40.9908 242.443 41.0521L242.127 41.0875C242.023 41.0937 241.921 41.0913 241.817 41.0945C241.637 41.1123 241.35 41.0767 241.109 41.0636C240.752 41.0339 240.301 40.9139 239.893 40.7597C239.047 40.4599 238.213 39.9955 237.345 39.5483C236.476 39.1012 235.544 38.6599 234.458 38.4887C233.921 38.406 233.333 38.4114 232.802 38.5583C232.271 38.7024 231.806 38.954 231.436 39.2449C231.253 39.3903 231.047 39.5614 230.924 39.6952C230.848 39.7778 230.8 39.8149 230.702 39.9287L230.5 40.1735C230.256 40.5007 230.063 40.8221 229.876 41.0951C229.693 41.3682 229.49 41.613 229.288 41.7869L229.143 41.9179C229.089 41.9607 229.007 41.998 228.94 42.0408C228.88 42.0751 228.82 42.1094 228.76 42.1465C228.69 42.1695 228.624 42.1953 228.561 42.2239C228.295 42.3272 228.042 42.4219 227.79 42.4769C227.54 42.5375 227.312 42.6094 227.101 42.6273C226.886 42.6594 226.696 42.6886 226.532 42.7149C226.358 42.7241 226.213 42.7333 226.096 42.7394C225.868 42.7461 225.742 42.7523 225.742 42.7523C225.742 42.7523 225.865 42.7716 226.099 42.8047Z"
        fill="#6ACBDD"
      />
      <g filter="url(#filter1_d_245_6871)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M78.768 133.112C84.7742 114.615 87.1661 101.381 85.9439 93.4099C84.8076 85.9989 80.3458 78.4775 72.5584 70.8456C71.5314 69.8392 69.903 69.7921 68.8197 70.7376C59.1092 79.2124 54.2539 87.1691 54.2539 94.6078C54.2539 102.52 55.7754 115.253 58.8184 132.807L78.768 133.112Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M78.4513 134.612C83.5277 114.714 85.55 100.717 84.518 92.6212C83.5725 85.203 79.5304 78.1428 72.3916 71.4405C71.2827 70.3994 69.5397 70.4543 68.4986 71.5632C68.4926 71.5696 68.4866 71.576 68.4807 71.5825C60.6628 80.0702 56.7538 88.0448 56.7538 95.5062C56.7538 103.542 58.3718 116.474 61.6077 134.302L78.4513 134.612Z"
          fill="#4E8B7C"
        />
        <path
          opacity={0.31685}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M74.9478 81.6322L75.8781 86.96C76.0525 87.959 75.3841 88.9102 74.3852 89.0846C74.2809 89.1028 74.1752 89.1119 74.0694 89.1119H67.4383C66.4242 89.1119 65.6022 88.2899 65.6022 87.2758C65.6022 87.17 65.6113 87.0643 65.6296 86.96L66.5598 81.6322C66.7133 80.7533 67.4763 80.1119 68.3685 80.1119H73.1391C74.0313 80.1119 74.7944 80.7533 74.9478 81.6322Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M77.7011 131.112C81.4697 117.696 82.9146 108.07 82.036 102.233C80.718 93.4781 58.2539 94.42 58.2539 103.11C58.2539 108.904 59.7906 118.227 62.864 131.079L77.7011 131.112Z"
          fill="#121626"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M82.2733 106.612C82.3058 104.649 82.322 101.504 82.322 97.1781C82.322 94.4453 76.4491 90.5559 70.9925 90.6129C65.1578 90.6738 60.5594 94.1765 59.4359 97.7451C58.6868 100.124 58.5548 103.08 59.0397 106.612C60.7447 100.578 64.9462 97.5615 71.6443 97.5615C78.3423 97.5615 81.8853 100.578 82.2733 106.612Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M72.7539 130.612V136.612H65.7539V134.172V130.612H72.7539Z"
          fill="#121626"
        />
        <path
          d="M64.5873 93.4453L65.9207 98.7786"
          stroke="#232F3E"
          strokeWidth={0.918048}
          strokeLinecap="square"
        />
        <path
          d="M75.3896 93.7884C75.7192 93.3684 75.8252 93.698 75.7074 94.7772C75.5896 95.8564 75.2718 97.4679 74.7539 99.6119"
          stroke="#232F3E"
          strokeWidth={0.918048}
          strokeLinecap="square"
        />
      </g>
      <g filter="url(#filter2_d_245_6871)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M123.059 33.1236C123.059 33.1236 106.803 43.5629 103.444 61.4592C100.086 79.3553 106.803 128.569 106.803 128.569C106.803 128.569 111.841 131.552 120.238 131.552C128.635 131.552 133.673 130.061 133.673 130.061C133.673 130.061 142.069 77.8637 138.711 61.4592C135.352 45.0544 123.06 33.1955 123.06 33.1955L123.059 33.1236Z"
          fill="#232F3E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M121.23 30.8617C121.23 30.8617 108.78 41.5686 105.83 59.9239C102.88 78.2788 108.78 128.755 108.78 128.755C108.78 128.755 113.206 131.814 120.581 131.814C127.957 131.814 132.382 130.285 132.382 130.285C132.382 130.285 139.757 76.749 136.807 59.9239C133.857 43.0984 121.23 30.8617 121.23 30.8617Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M120.383 36.5403C120.383 36.5403 104.939 47.6265 108.727 80.707C108.727 80.707 111.641 78.8981 120.383 78.8981C129.124 78.8981 132.038 80.707 132.038 80.707C132.038 80.707 140.402 52.7597 122.383 36.5403H120.383Z"
          fill="#E8282F"
        />
        <path
          opacity={0.250873}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M116.541 128.659C113.388 128.659 110.832 125.381 110.832 121.338L109.379 86.7666C109.379 82.7231 111.935 79.445 115.088 79.445H128.67C131.823 79.445 134.379 82.7231 134.379 86.7666L132.635 121.338C132.635 125.381 130.079 128.659 126.926 128.659H116.541Z"
          fill="#232F3E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M126.254 125.505V136.862H115.254V131.376V125.505H126.254Z"
          fill="#121626"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M126.806 99.0046H115.382C111.914 99.0046 109.103 97.1555 109.103 94.8745L107.504 75.3728C107.504 73.0918 110.315 71.2427 113.783 71.2427H128.724C132.192 71.2427 135.004 73.0918 135.004 75.3728L133.085 94.8745C133.085 97.1555 130.274 99.0046 126.806 99.0046Z"
          fill="#232F3E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M110.629 82.089C110.629 80.6288 112.469 79.445 114.739 79.445H115.992C118.263 79.445 120.103 80.6288 120.103 82.089V85.1236H110.629V82.089Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M120.629 82.089C120.629 80.6288 122.523 79.445 124.86 79.445H126.149C128.486 79.445 130.38 80.6288 130.38 82.089L130.629 85.1236H120.629V82.089Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M110.629 87.1032C110.629 87.7522 112.469 88.2783 114.739 88.2783H115.992C118.263 88.2783 120.103 87.7522 120.103 87.1032V85.7545H110.629V87.1032Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M120.629 87.1032C120.629 87.7522 122.523 88.2783 124.86 88.2783H126.149C128.486 88.2783 130.38 87.7522 130.38 87.1032L130.629 85.7545H120.629V87.1032Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M106.254 73.1376C106.254 73.1376 108.259 67.8514 120.004 68.8426V78.0935C120.004 78.0935 112.842 78.0935 109.978 80.076L106.254 73.1376Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M135.004 73.1376C135.004 73.1376 132.999 67.8514 121.254 68.8426V78.0935C121.254 78.0935 128.416 78.0935 131.28 80.076L135.004 73.1376Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M120.879 69.3498H122.129V46.6355H120.879V69.3498Z"
          fill="white"
        />
      </g>
      <rect
        x={53.5039}
        y={157.415}
        width={172}
        height={14}
        rx={7}
        fill="#EEF2F6"
      />
      <path
        d="M53.5039 164.415C53.5039 160.549 56.6379 157.415 60.5039 157.415H73.5039V171.415H60.5039C56.6379 171.415 53.5039 168.281 53.5039 164.415Z"
        fill="#86B0A5"
      />
      <path
        d="M73.5039 157.415H203.504V171.415H73.5039V157.415Z"
        fill="#86B0A5"
      />
      <path
        d="M203.504 157.415H218.504C222.37 157.415 225.504 160.549 225.504 164.415C225.504 168.281 222.37 171.415 218.504 171.415H203.504V157.415Z"
        fill="#EEF2F6"
      />
      <path
        d="M35.4219 165.855C35.4219 166.547 35.3672 167.164 35.2578 167.707C35.1523 168.25 34.9805 168.711 34.7422 169.089C34.5078 169.468 34.1992 169.757 33.8164 169.957C33.4336 170.156 32.9688 170.255 32.4219 170.255C31.7344 170.255 31.1699 170.082 30.7285 169.734C30.2871 169.382 29.9609 168.879 29.75 168.222C29.5391 167.562 29.4336 166.773 29.4336 165.855C29.4336 164.929 29.5293 164.138 29.7207 163.482C29.916 162.822 30.2324 162.316 30.6699 161.964C31.1074 161.613 31.6914 161.437 32.4219 161.437C33.1055 161.437 33.668 161.613 34.1094 161.964C34.5547 162.312 34.8848 162.816 35.0996 163.476C35.3145 164.132 35.4219 164.925 35.4219 165.855ZM31.2324 165.855C31.2324 166.507 31.2676 167.052 31.3379 167.49C31.4121 167.923 31.5352 168.25 31.707 168.468C31.8789 168.687 32.1172 168.797 32.4219 168.797C32.7227 168.797 32.959 168.689 33.1309 168.474C33.3066 168.255 33.4316 167.929 33.5059 167.496C33.5801 167.058 33.6172 166.511 33.6172 165.855C33.6172 165.203 33.5801 164.658 33.5059 164.22C33.4316 163.783 33.3066 163.455 33.1309 163.236C32.959 163.013 32.7227 162.902 32.4219 162.902C32.1172 162.902 31.8789 163.013 31.707 163.236C31.5352 163.455 31.4121 163.783 31.3379 164.22C31.2676 164.658 31.2324 165.203 31.2324 165.855ZM38.2578 161.449C38.9297 161.449 39.4395 161.683 39.7871 162.152C40.1348 162.621 40.3086 163.279 40.3086 164.127C40.3086 164.974 40.1445 165.636 39.8164 166.113C39.4883 166.589 38.9688 166.828 38.2578 166.828C37.5977 166.828 37.0957 166.589 36.752 166.113C36.4082 165.636 36.2363 164.974 36.2363 164.127C36.2363 163.279 36.3965 162.621 36.7168 162.152C37.041 161.683 37.5547 161.449 38.2578 161.449ZM38.2695 162.673C38.0781 162.673 37.9375 162.795 37.8477 163.037C37.7578 163.279 37.7129 163.646 37.7129 164.138C37.7129 164.63 37.7578 165 37.8477 165.246C37.9375 165.492 38.0781 165.615 38.2695 165.615C38.4609 165.615 38.6016 165.494 38.6914 165.252C38.7852 165.005 38.832 164.634 38.832 164.138C38.832 163.646 38.7852 163.279 38.6914 163.037C38.6016 162.795 38.4609 162.673 38.2695 162.673ZM44.3398 161.572L39.5879 170.138H38.1816L42.9336 161.572H44.3398ZM44.2578 164.871C44.9297 164.871 45.4395 165.105 45.7871 165.574C46.1348 166.043 46.3086 166.701 46.3086 167.548C46.3086 168.392 46.1445 169.052 45.8164 169.529C45.4883 170.005 44.9688 170.244 44.2578 170.244C43.5977 170.244 43.0957 170.005 42.752 169.529C42.4082 169.052 42.2363 168.392 42.2363 167.548C42.2363 166.701 42.3965 166.043 42.7168 165.574C43.041 165.105 43.5547 164.871 44.2578 164.871ZM44.2695 166.095C44.0781 166.095 43.9375 166.216 43.8477 166.459C43.7578 166.701 43.7129 167.068 43.7129 167.56C43.7129 168.052 43.7578 168.422 43.8477 168.668C43.9375 168.914 44.0781 169.037 44.2695 169.037C44.4609 169.037 44.6016 168.916 44.6914 168.673C44.7852 168.427 44.832 168.056 44.832 167.56C44.832 167.068 44.7852 166.701 44.6914 166.459C44.6016 166.216 44.4609 166.095 44.2695 166.095Z"
        fill="#6A788A"
      />
      <path
        d="M233.617 166.297V165.863C233.617 165.597 233.654 165.363 233.729 165.16C233.803 164.953 233.922 164.757 234.086 164.574C234.25 164.386 234.467 164.195 234.736 164C234.979 163.828 235.172 163.673 235.316 163.537C235.465 163.4 235.572 163.265 235.639 163.132C235.709 162.996 235.744 162.841 235.744 162.67C235.744 162.416 235.65 162.222 235.463 162.089C235.275 161.957 235.014 161.89 234.678 161.89C234.342 161.89 234.008 161.943 233.676 162.048C233.348 162.154 233.014 162.293 232.674 162.464L232.035 161.181C232.426 160.963 232.85 160.787 233.307 160.654C233.764 160.517 234.264 160.449 234.807 160.449C235.643 160.449 236.289 160.65 236.746 161.052C237.207 161.451 237.438 161.959 237.438 162.576C237.438 162.904 237.385 163.189 237.279 163.431C237.178 163.67 237.021 163.892 236.811 164.099C236.604 164.302 236.344 164.517 236.031 164.744C235.797 164.916 235.617 165.06 235.492 165.177C235.367 165.295 235.281 165.412 235.234 165.529C235.191 165.642 235.17 165.781 235.17 165.945V166.297H233.617ZM233.43 168.3C233.43 167.933 233.529 167.675 233.729 167.527C233.932 167.379 234.176 167.304 234.461 167.304C234.738 167.304 234.977 167.379 235.176 167.527C235.379 167.675 235.48 167.933 235.48 168.3C235.48 168.652 235.379 168.906 235.176 169.062C234.977 169.218 234.738 169.297 234.461 169.297C234.176 169.297 233.932 169.218 233.729 169.062C233.529 168.906 233.43 168.652 233.43 168.3ZM239.348 166.297V165.863C239.348 165.597 239.385 165.363 239.459 165.16C239.533 164.953 239.652 164.757 239.816 164.574C239.98 164.386 240.197 164.195 240.467 164C240.709 163.828 240.902 163.673 241.047 163.537C241.195 163.4 241.303 163.265 241.369 163.132C241.439 162.996 241.475 162.841 241.475 162.67C241.475 162.416 241.381 162.222 241.193 162.089C241.006 161.957 240.744 161.89 240.408 161.89C240.072 161.89 239.738 161.943 239.406 162.048C239.078 162.154 238.744 162.293 238.404 162.464L237.766 161.181C238.156 160.963 238.58 160.787 239.037 160.654C239.494 160.517 239.994 160.449 240.537 160.449C241.373 160.449 242.02 160.65 242.477 161.052C242.938 161.451 243.168 161.959 243.168 162.576C243.168 162.904 243.115 163.189 243.01 163.431C242.908 163.67 242.752 163.892 242.541 164.099C242.334 164.302 242.074 164.517 241.762 164.744C241.527 164.916 241.348 165.06 241.223 165.177C241.098 165.295 241.012 165.412 240.965 165.529C240.922 165.642 240.9 165.781 240.9 165.945V166.297H239.348ZM239.16 168.3C239.16 167.933 239.26 167.675 239.459 167.527C239.662 167.379 239.906 167.304 240.191 167.304C240.469 167.304 240.707 167.379 240.906 167.527C241.109 167.675 241.211 167.933 241.211 168.3C241.211 168.652 241.109 168.906 240.906 169.062C240.707 169.218 240.469 169.297 240.191 169.297C239.906 169.297 239.662 169.218 239.459 169.062C239.26 168.906 239.16 168.652 239.16 168.3Z"
        fill="#6A788A"
      />
      <defs>
        <filter
          id="filter0_d_245_6871"
          x={150.504}
          y={0.861694}
          width={52}
          height={143}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={2.5} />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0660051 0 0 0 0 0.0806885 0 0 0 0 0.149267 0 0 0 0.159406 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_245_6871"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_245_6871"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_245_6871"
          x={49.2539}
          y={67.0585}
          width={42}
          height={76.5535}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={2.5} />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0660051 0 0 0 0 0.0806885 0 0 0 0 0.149267 0 0 0 0.159406 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_245_6871"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_245_6871"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_245_6871"
          x={97.5039}
          y={27.8617}
          width={47}
          height={116}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={2.5} />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0660051 0 0 0 0 0.0806885 0 0 0 0 0.149267 0 0 0 0.159406 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_245_6871"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_245_6871"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default EmptyStateImage
